import { clearable, tripSupplierCollection, userConstatnt, hotelRateInventory, bookingConstant, activityRateInventory } from "../_constants/user.constant";


const initialValues = {
    tba: []
}
const clearinitial = {
    clear: false,
    clearerror: false
}
const tripSupplierCollectioninitial = {
    supplierCollection: true
}
const hotelInitialValue = {
    isUpdate: false
}
const activityInitialValue = {
    isUpdate: false
}
const bookingInitialValue = {
    isUpdateBooking: false
}

export function userstatus(state = initialValues, actions) {
    switch (actions.type) {
        case userConstatnt.USERDATA:
            return { tba: actions.tba };
        default:
            return state;
    }
}
export function menuid(state = 0, actions) {
    switch (actions.type) {
        case userConstatnt.MENUID:
            return { menuId: actions.menuId };
        default:
            return state;
    }
}

export function isClear(state = clearinitial, actions) {
    switch (actions.type) {
        case clearable.CLEARTRUE:
            return { clear: true, clearerror: false };
        case clearable.CLEARFALSE:
            return { clear: false, clearerror: false };
        case clearable.CLEARERRORTRUE:
            return { clear: false, clearerror: true };
        case clearable.CLEARERRORFALSE:
            return { clear: false, clearerror: false };
        default:
            return state;
    }
}

export function isTripSupplierCollection(state = tripSupplierCollectioninitial, actions) {
    switch (actions.type) {
        case tripSupplierCollection.YES:
            return { supplierCollection: true };
        case tripSupplierCollection.NO:
            return { supplierCollection: false };
        default:
            return state;
    }
}

export function hotelrateinventory(state = hotelInitialValue, actions) {
    switch (actions.type) {
        case hotelRateInventory.HOTELRATEINVENTORYOPEN:
            return { ...state, isUpdate: true };
        case hotelRateInventory.HOTELRATEINVENTORYCLOSE:
            return { ...state, isUpdate: false };
        default:
            return state;
    }
}

export function activityrateInventory(state = activityInitialValue, actions) {
    switch (actions.type) {
        case activityRateInventory.ACTIVITYRATEINVENTORYOPEN:
            return { ...state, isUpdate: true };
        case activityRateInventory.ACTIVITYRATEINVENTORYCLOSE:
            return { ...state, isUpdate: false };
        default:
            return state;
    }
}


export function booking(state = bookingInitialValue, actions) {
    switch (actions.type) {
        case bookingConstant.UPDATEBOOKING:
            return { isUpdateBooking: true };
        case bookingConstant.UPDATEBOOKINGEND:
            return { isUpdateBooking: false };
        default:
            return state;
    }
}